const Subtitle = ({children}) => {
    const subtitleStyles = {
        marginBottom: '1em',
        color: '#9F9FA9'
    }

    return (
        <p style={subtitleStyles}>{children}</p>
    );
}

export default Subtitle;